import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import Vuetify from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'
import { THEME_SETTINGS } from '@/settings'

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
library.add(fas, far)

const opts = {
  directives: {
    Ripple
  },
  theme: {
    themes: {
      light: {
        primary: THEME_SETTINGS.LIGHT_PRIMARY,
        secondary: THEME_SETTINGS.LIGHT_SECONDARY,
        pop: THEME_SETTINGS.LIGHT_POP,
        accent: THEME_SETTINGS.LIGHT_ACCENT,
        error: THEME_SETTINGS.LIGHT_ERROR,
        textFont: THEME_SETTINGS.LIGHT_TEXT_FONT,
        textFontInverted: THEME_SETTINGS.LIGHT_TEXT_FONT_INVERTED
      },
      dark: {
        primary: THEME_SETTINGS.DARK_PRIMARY,
        secondary: THEME_SETTINGS.DARK_SECONDARY,
        pop: THEME_SETTINGS.DARK_POP,
        accent: THEME_SETTINGS.DARK_ACCENT,
        error: THEME_SETTINGS.DARK_ERROR,
        textFont: THEME_SETTINGS.LIGHT_TEXT_FONT,
        textFontInverted: THEME_SETTINGS.LIGHT_TEXT_FONT_INVERTED
      }
    }
  },
  icons: {
    iconfont: 'faSvg'
  }
}

Vue.use(Vuetify, opts)

export default new Vuetify(opts)
